export function productHasVariants(p) {
  return Array.isArray(p?.variants) && p.variants.length > 0;
}

export function variantLabel(v) {
  if (!v) return "";
  if (v.name) return String(v.name);
  const a = v.attributes || {};
  const parts = [a.size, a.color].filter(Boolean);
  return parts.join(" / ") || "Option";
}

export function variantAxes(product) {
  const variants = product?.variants || [];
  const sizes = Array.from(new Set(variants.map((v) => v.attributes?.size).filter(Boolean)));
  const colors = Array.from(new Set(variants.map((v) => v.attributes?.color).filter(Boolean)));
  const colorHex = {};
  variants.forEach((v) => {
    if (v.attributes?.color && v.attributes?.color_hex) colorHex[v.attributes.color] = v.attributes.color_hex;
  });
  return { sizes, colors, colorHex };
}

export function findVariant(product, nextSize, nextColor) {
  return (product?.variants || []).find((v) => (
    (nextSize ? v.attributes?.size === nextSize : true)
    && (nextColor ? v.attributes?.color === nextColor : true)
  ));
}
